import React, { useContext } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import CardTypeForm from "../CardTypeForm";
import LocationForm from "../LocationForm";
import LimitSearchHeader from "./LimitSearchHeader";

const LimitSearch = () => {
  const { showAddressForm, showCardTypeForm } = useContext(GlobalContext);

  return (
    <div className="gog-limit-search">
      <div className="gog-search-card">
        <LimitSearchHeader />
      </div>

      {showAddressForm && (
        <div className="gog-search-card gog-search-card-nested">
          <LocationForm />
        </div>
      )}

      {showCardTypeForm && (
        <div className="gog-search-card gog-search-card-nested">
          <CardTypeForm />
        </div>
      )}
    </div>
  );
};

export default LimitSearch;